import * as React from "react";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";


export default class SystemCrash extends React.Component {

    componentDidMount() {
        logUI("MBHWeb.UI.SystemCrash.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    // Here is our official "faceplant" message
    render() {
        return (<React.Fragment>
            <div className="container-fluid app-crash-container body-content logged-out-container">
                <div className="row">
                    <div className="col-12 maxWidth-content">
                        <div className="section-error-container not-available-error">
                            <div className="row">
                                <div className="col-12 align-self-center">
                                    <div className="row section-error__header">
                                        <div className="col-12">
                                            <div className="section-error__header--title">
                                                <span className="icon-info" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row section-error__body">
                                        <div className="col-12">
                                            <div className="section-error__body--message">
                                                We are currently experiencing technical difficulties. Please try again.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>);
    }

}
